"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetServerTimeRequest = void 0;
var GetServerTimeRequest = /** @class */ (function () {
    function GetServerTimeRequest() {
    }
    return GetServerTimeRequest;
}());
exports.GetServerTimeRequest = GetServerTimeRequest;
;
//# sourceMappingURL=getServerTime.request.js.map